import React from 'react';
var redirectURL = require('../redirectURL');

const Allactioncomponentforvendor = (props) => {
  const handleClick = (type, e) => {
    e.stopPropagation();
    const context = props.context.componentParent;

    switch (type) {
      case 'material':
        context.onClickshowbiddata(props);
        break;
      case 'attachment':
        context.onClickViewPOD(props);
        break;
      case 'comment':
        context.onClickComments(props);
        break;
      case 'bidding':
        context.onClickviewRFQ(props);
        break;
      case 'notification':
        context.fetchNotificationsData(props);
        break;
      default:
        break;
    }
  };

  const isBiddingWindowExpired = (biddingWindow, createDate) => {
    if (!biddingWindow || !biddingWindow.includes(':') || !createDate) {
      return true;
    }

    const [hours, minutes] = biddingWindow.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) {
      return true;
    }

    const localCreateDate = new Date(createDate.replace('Z', '') + '+05:30');
    const biddingEndTime = new Date(localCreateDate);
    biddingEndTime.setHours(biddingEndTime.getHours() + hours);
    biddingEndTime.setMinutes(biddingEndTime.getMinutes() + minutes);

    return new Date() > biddingEndTime;
  };

  const indent = props.data.indent;
  const vendorQuotes = indent && Array.isArray(indent.vendorquotes) ? indent.vendorquotes : [];
  const currentVendorEmail = localStorage.getItem('email');
  const hasVendorQuote = vendorQuotes.some(x => x.vendor_email_id === currentVendorEmail);
  const isBidEnabled =
    indent &&
    hasVendorQuote &&
    indent.validity_end !== 1 &&
    indent.vehicle_placement_expiried !== 1 &&
    isBiddingWindowExpired(indent.bidding_window, indent.create_date);

  const fields = [
    { label: 'Additional Comments', value: indent.additional_comments },
    { label: 'Vendor Rejection Reason', value: indent.reasonforrejectionbyvendor },
    { label: 'Admin Rejection Reason', value: indent.rejected_reason_by_approval1 },
    { label: 'Danish Rejection Reason', value: indent.rejection_reason_for_superadmin },
  ];
  const hasComments = fields.some(field => field.value && field.value.trim() !== '');

  const unreadCount = indent.notification_count;

  return (
    <div style={{ display: 'flex', gap: '5px', position: 'relative' }}>
      {/* Bid */}
      <button
        onClick={(e) => {
          if (isBidEnabled) {
            handleClick('material', e);
          }
        }}
        className="custom-btn label label-success"
        title="Bid Details"
      >
        <img
          src={require(`../../assets/images/${isBidEnabled ? 'Group 976.png' : 'biddetailsdisable.png'}`)}
          alt="Bid Details"
        />
      </button>

      {/* Attachment */}
      <button
        onClick={(e) => {
          if (indent && indent.upload_for_road !== '') {
            handleClick('attachment', e);
          }
        }}
        className="custom-btn label label-success"
        title="Attachment"
      >
        <img
          src={require(`../../assets/images/${indent.upload_for_road ? 'downloadenable.png' : 'downloading.png'}`)}
          alt="Attachment"
        />
      </button>

      {/* Comments */}
      {hasComments ? (
        <button
          onClick={(e) => handleClick('comment', e)}
          className="custom-btn label label-success"
          title="Comments"
        >
          <img
            src={require('../../assets/images/chat.png')}
            style={{ cursor: 'pointer' }}
            alt="Comments"
          />
        </button>
      ) : (
        <button
          disabled
          className="custom-btn label label-secondary"
          title="No Comments"
          style={{ cursor: 'pointer' }}
        >
          <img
            src={require('../../assets/icons/chat.png')}
            style={{ opacity: 0.5 }}
            alt="No Comments"
          />
        </button>
      )}

      {/* View RFQ */}
      <button
        onClick={(e) => handleClick('bidding', e)}
        className="custom-btn label label-success"
        title="View Indent"
      >
        <img src={require('../../assets/images/viewindent.png')} alt="RFQ" />
      </button>

      {/* Notifications */}
      <div style={{ position: 'relative' }}>
        <button
          onClick={(e) => handleClick('notification', e)}
          className="custom-btn label label-success"
          title="Notifications"
        >
          <img src={require('../../assets/images/notifications.png')} alt="Notifications" />
          {unreadCount > 0 && (
            <span
              style={{
                position: 'absolute',
                right: '-1px',
                top: '-1px',
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '50%',
                padding: '2px 4px',
                fontSize: '8px',
                fontWeight: 'bold',
                lineHeight: '1',
                pointerEvents: 'none',
              }}
            >
              {unreadCount}
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default Allactioncomponentforvendor;
